// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Heading_wrapper__5CHV6","wrapperSecondary":"Heading_wrapperSecondary__2fSr8","wrapperWithBorder":"Heading_wrapperWithBorder__2ft1K","children":"Heading_children__13F1q"};